/**
 * atomberg-delivery-state.js
 *
 * Lets PDP blocks react to the delivery check without being part of it.
 * atomberg-delivery-check.js dispatches `atomberg:delivery-state` (bubbling)
 * from its root and mirrors each settled state onto that root as
 * data-adc-state / data-adc-state-pincode, so a block that binds after the
 * check has already resolved still starts in step.
 *
 *   state          when
 *   typed          the field holds a full 6-digit pincode, not yet checked
 *   serviceable    a check passed
 *   unserviceable  a check failed
 *   reset          Change was pressed — back to the empty field
 *   unavailable    the selected variant is out of stock, so the check is hidden
 *
 * API (window.AtombergDeliveryState):
 *   subscribe(el, cb) — calls cb(state, pincode) once with the current settled
 *     state ('' when nothing has been checked), then on every change from the
 *     delivery check in el's own section. The cart drawer's check never matches.
 */
(function () {
  'use strict';

  /** @type {any} */
  var w = window;
  if (w.AtombergDeliveryState) return;

  var EVENT = 'atomberg:delivery-state';

  /**
   * @param {HTMLElement} el
   * @param {(state: string, pincode: string) => void} cb
   */
  function subscribe(el, cb) {
    var scope = el.closest('.shopify-section') || document;
    var check = scope.querySelector('[data-atomberg-delivery-check]');
    cb(
      (check && check.getAttribute('data-adc-state')) || '',
      (check && check.getAttribute('data-adc-state-pincode')) || ''
    );
    // Listening on document, not the check itself, survives a morph replacing its root
    document.addEventListener(EVENT, function (/** @type {any} */ e) {
      if (!(e.target instanceof Node) || !scope.contains(e.target)) return;
      var detail = e.detail || {};
      cb(detail.state || '', detail.pincode || '');
    });
  }

  w.AtombergDeliveryState = { subscribe: subscribe };
})();
